import React from 'react';
import PropTypes from 'prop-types';
import SelectBox from '@adsk/alloy-select-box';
import FormField from '@adsk/alloy-react-form-field';
import { useLocale } from '@adsk/alloy-react-helpers';
import { SERVICE_ACCESSES } from '@common/constants';
import AccountAccessFieldOption from '../AccountAccessFieldOption';
import AccountAccessFieldTag from '../AccountAccessFieldTag';
import { menuStyle } from './helpers/styles';

const AccountAccessField = ({
  accessLevels,
  container,
  onAccessLevelChange,
  selectedAccessLevel,
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const getIsOptionDisabled = (optionValue) =>
    optionValue === SERVICE_ACCESSES.ADMIN ||
    optionValue === SERVICE_ACCESSES.MEMBER;

  return (
    <FormField
      data-testid="AccountMemberProfile_accountAccessField"
      label={T.translate('ACCESS_LABEL')}
      labelVariant={FormField.LABEL_VARIANTS.TOP}
      style={{ paddingTop: '20px' }}
    >
      <SelectBox
        container={container}
        data-testid="AccountMemberProfile_account_access_field"
        isOptionDisabled={(option) => getIsOptionDisabled(option.value)}
        menuStyle={menuStyle}
        multiple
        onChange={onAccessLevelChange}
        optionRenderer={(option) => (
          <AccountAccessFieldOption
            getIsOptionDisabled={getIsOptionDisabled}
            option={option}
            selectedAccessLevel={selectedAccessLevel}
          />
        )}
        options={accessLevels}
        showValueAsTags
        value={selectedAccessLevel}
        valueTagRenderer={(selectedAccess) => (
          <AccountAccessFieldTag
            selectedAccess={selectedAccess}
            selectedAccessLevel={selectedAccessLevel}
          />
        )}
      />
    </FormField>
  );
};

AccountAccessField.propTypes = {
  accessLevels: PropTypes.array.isRequired,
  container: PropTypes.instanceOf(Element),
  onAccessLevelChange: PropTypes.func.isRequired,
  selectedAccessLevel: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    .isRequired,
};

export default AccountAccessField;
